"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_business__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "0b3e584e-12b0-4354-969a-7d276880d645",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a7a98524-850d-4e6e-a491-dcc89634723a",
    x1: 83.86,
    y1: 117.08,
    x2: 142.09,
    y2: 175.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "business-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "9d2165df-8efc-4f54-bb12-d582d8c40ace",
    "data-name": "Business_ic_hi 2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "8750547e-0a65-4f90-a8e0-a8a1acbfa336",
    "data-name": "<Pfad>",
    cx: 96,
    cy: 57.94,
    r: 38.16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd491233-ca51-47b2-ac7b-0a037ecc6d6e",
    "data-name": "<Pfad>",
    d: "M147.85,166.68A12,12,0,0,0,157,151.9c-9.61-38-35.23-55.8-60.66-55.8S44.73,113.84,35,151.86a12,12,0,0,0,9.18,14.82,255.48,255.48,0,0,0,52,5.32A255.48,255.48,0,0,0,147.85,166.68Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.73,95a38.15,38.15,0,0,0,47.43-37c0-.34,0-.67,0-1a38.14,38.14,0,0,1-76.26,0c0,.33,0,.66,0,1A38.17,38.17,0,0,0,86.73,95Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.36,153.92a12,12,0,0,1-9.51,10.76A255.47,255.47,0,0,1,96.13,170a255.48,255.48,0,0,1-52-5.32,12,12,0,0,1-9.51-10.77,12,12,0,0,0,9.51,12.77,255.48,255.48,0,0,0,52,5.32,255.47,255.47,0,0,0,51.72-5.32A12,12,0,0,0,157.36,153.92Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.59,151.78,102.4,113.3a6.43,6.43,0,0,0-12.79,0l-4.19,38.5a2,2,0,0,0,.47,1.52l8.6,10a2,2,0,0,0,3,0l8.6-10A2,2,0,0,0,106.59,151.78Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,108H92a4,4,0,0,1,0-8h8a4,4,0,0,1,0,8Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.47,150.67a2,2,0,0,1-.35.61l-8.6,10a2,2,0,0,1-3,0l-8.6-10a2,2,0,0,1-.35-.61l-.12,1.11a2,2,0,0,0,.47,1.52l8.6,10a2,2,0,0,0,3,0l8.6-10a2,2,0,0,0,.47-1.52Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,106H92a4,4,0,0,1-3.86-3A4,4,0,0,0,92,108h8a4,4,0,0,0,3.86-5A4,4,0,0,1,100,106Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.34,101.4l-.17.05a4,4,0,0,1-3.06,6.55H98.55a6.41,6.41,0,0,1,4,5.3l4.19,38.49a2,2,0,0,1-.47,1.52l-8.6,10a1.94,1.94,0,0,1-2.13.59l8,8a255.54,255.54,0,0,0,44.45-5.21,12,12,0,0,0,9.54-11.14Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#a7a98524-850d-4e6e-a491-dcc89634723a)"
  })));
}

var _default = ic_business__dark;
exports.default = _default;